import { render, staticRenderFns } from "./Swipe.vue?vue&type=template&id=b06c5558&scoped=true&"
import script from "./Swipe.vue?vue&type=script&lang=js&"
export * from "./Swipe.vue?vue&type=script&lang=js&"
import style0 from "./Swipe.vue?vue&type=style&index=0&id=b06c5558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c5558",
  null
  
)

export default component.exports